import ApiService from "../axios";
import { API_LAYER_URL } from "../../config";

export const ProductService = {
  getAllBy(params) {
    ApiService.setBaseUrl(API_LAYER_URL);
    return ApiService.getAll(
      `/api/supplier/get-products?supplierId=${params.supplierId}&merchantId=${params.merchantId}&isNotSpecific=${params.isNotSpecific}`
    );
  },
  getAll() {
    ApiService.setBaseUrl(API_LAYER_URL);
    return ApiService.getAll(`/api/get-all-products`);
  },
  get(id) {
    ApiService.setBaseUrl(API_LAYER_URL);
    return ApiService.get(`/api/product/${id}/get`, id);
  },
  async create(payload) {
    ApiService.setBaseUrl(API_LAYER_URL);
    return await ApiService.post("/api/product/create", payload);
  },
  update(payload) {
    ApiService.setBaseUrl(API_LAYER_URL);
    return ApiService.update("/api/product/update", payload);
  },
  delete(payload) {
    ApiService.setBaseUrl(API_LAYER_URL);
    return ApiService.post(`/api/product/delete`, payload);
  }
};



// WEBPACK FOOTER //
// ./src/http/services/product.js